// Return null for unfixed items so their existing fixation workflow applies.
export const calculateFixedShipmentInvoice = (shipmentItems = [], dealItems = []) => {
  if (!shipmentItems.length) return null;
  let total = 0;
  for (const shipmentItem of shipmentItems) {
    const dealItem = dealItems.find(item => shipmentItem.dealItemId &&
      String(item.DealItemID ?? item.dealItemId) === String(shipmentItem.dealItemId)) ||
      dealItems.find(item => shipmentItem.itemId &&
        String(item.ItemID ?? item.ItemId ?? item.itemId) === String(shipmentItem.itemId));
    if (!dealItem || dealItem.PriceMode !== "Fixed") return null;
    const rate = Number(dealItem.Rate);
    const weight = Number(shipmentItem.netWeight || 0);
    if (dealItem.Rate == null || dealItem.Rate === "" || !Number.isFinite(rate) || !Number.isFinite(weight)) return null;
    total += Number((rate * weight).toFixed(2));
  }
  return Number(total.toFixed(2));
};
